<div class="flow-search-input-wrapper">
  @if (label) {
    <label class="flow-search-input-label" [for]="fieldId" agText="body-3-medium">{{ label }}</label>
  }

  <div [ngClass]="['flow-search-input', focused ? 'focused' : '', hasValue ? 'typing' : '', error ? 'error' : '', disabled ? 'disabled' : '']">
    <span class="icon-wrapper leading" aria-hidden="true">
      <img [src]="iconService.Icon.magnifier" class="icon" />
    </span>

    <input #field [id]="fieldId" type="text" class="search-field" [value]="value" [placeholder]="placeholder" [disabled]="disabled" [attr.maxlength]="maxLength" (input)="onInput(field.value)" (focus)="onFocus()" (blur)="onBlur()" />

    @if (showClear) {
      <button type="button" class="clear-button" aria-label="Clear" (click)="onClear()">
        <span class="icon-wrapper" aria-hidden="true">
          <img [src]="iconService.Icon.cross" class="icon" />
        </span>
      </button>
    }

    @if (showSearchButton) {
      <flow-button-v2 class="search-button" size="small" label="Search" type="secondary" [loading]="loading" [disabled]="!canSearch || disabled" (click)="onSearch()"></flow-button-v2>
    }
  </div>

  @if (showHelper) {
    <flow-helper-text [helperText]="helperText" [variant]="error ? 'destructive' : 'default'" [characterCount]="characterCount" [maxCount]="maxLength"></flow-helper-text>
  }
</div>
